import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { routes } from './our-homes.routes';

import { ListingComponent } from './components/listing.component'
import { ListingsComponent } from './components/listings.component';
import { ListingsTileComponent } from './components/listings-tile.component';
import { OurHomesComponent } from './components/our-homes.component';
import { ListingsMapComponent } from './components/listings-map.component';
import { ListingMapComponent } from './components/listing-map.component';
import { ListingMapPinComponent } from './components/listing-map-pin.component';

// import { ShareButtonsModule } from '@ngx-share/';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MarketingBannerComponent } from './components/marketing-banner.component';

// import { AgmCoreModule } from '@agm/core';
import { environment } from 'environments/environment';
import { SavingsLinkComponent } from './components/savings-link.component';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MediaModule } from 'app/modules/media/media.module';
import { ExternalContentModule } from 'app/external-content/external-content.module';
import { ListingContactComponent } from './components/listing-contact.component';
import { NewSharedModule } from 'app/new_shared/new-shared.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PipesModule } from 'app/modules/pipes/pipes.module';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [
    ListingComponent,
    ListingsComponent,
    ListingsTileComponent,
    OurHomesComponent,
    MarketingBannerComponent,
    ListingsMapComponent,
    ListingMapComponent,
    ListingMapPinComponent,
    SavingsLinkComponent,
    ListingContactComponent,
  ],
  imports: [
    PipesModule,
    MediaModule,
    FormsModule,
    TooltipModule.forRoot(),
    RouterModule.forChild(routes),
    ExternalContentModule,
    HttpClientModule,
    NewSharedModule,
    MatPaginatorModule,
    GoogleMapsModule,
  ],
  providers: [],
  exports: [
    RouterModule
  ]
})
export class OurHomesModule { }
